import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3121, { U3121ROLES } from "./U3121";
import U3121ProjectList from "./components/U3121ProjectList";
import U3121ProjectForm from "./components/U3121ProjectForm";
import U3121SubProjectForm from "./components/U3121SubProjectForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3121Routes: RouteObject[] = [
  {
    path: "U3121",
    element: <U2000RequireRole allowedRoles={[U3121ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3121 />,
        children: [
          { index: true, element: <U3121ProjectList /> },
          {
            path: ":projectId/subproject/:subProjectId",
            element: <U3121SubProjectForm />,
          },
          {
            path: ":projectId/subproject/create",
            element: <U3121SubProjectForm />,
          },
          { path: "create", element: <U3121ProjectForm /> },
          { path: ":id", element: <U3121ProjectForm /> },
        ],
      },
    ],
  },
];

export default U3121Routes;
